module.exports = __webpack_public_path__ + "img/icon_resume2.f5a833a8.svg";